import * as sites from 'app/mocks/data/park/sites/list'

import { TypeMachine } from 'app/types/shared/machine'

export const terminal1 = {
    id: 101,
    name: 'Borne 1 mock',
    site: sites.site1,
    category: TypeMachine.enum.TERMINAL,
    description: '',
    stock_usage_percentage: 0,
    number_of_products: 0,
    max_products: 7,
    provider: '',
    software_version: '10',
    build_date: '2023-10-31',
    installation_date: '2023-10-31',
    distributor_volume: 10,
    connexion_type: 'et',
    paiement_method: 'ts',
    private_id: '',
    mode: '',
    enabled: false,
    online: false,
    is_low_stock: false,
    is_high_stock: false,
    percentage_stock_alarm: 10,
    percentage_high_stock_alarm: 10,
    time_high_stock_check: '11:00:00',
    minimum_credit: 10,
    payment_priority: 'CP,CB,TRD',
    temperature_unit: '°C',
    weight_unit: 'g',
    volume_unit: 'l',
    currency: '€',
    default_locale_customer: 'en-GB',
    default_locale_intervenor: 'fr-FR',
    has_coin_acceptor: true,
    has_banknote_reader: false,
    has_printer: true,
    has_id_card_reader: false,
    has_ask_age_confirmation: false,
    has_icoupon: true,
    user: 165,
    components: [],
}

export const terminal2 = {
    id: 102,
    name: 'Borne 2 mock',
    site: sites.site11,
    category: TypeMachine.enum.TERMINAL,
    description: '',
    stock_usage_percentage: 0,
    number_of_products: 0,
    max_products: 7,
    provider: '',
    software_version: '10',
    build_date: '2023-10-31',
    installation_date: '2023-10-31',
    distributor_volume: 10,
    connexion_type: 'et',
    paiement_method: 'ts',
    private_id: '',
    mode: '',
    enabled: false,
    online: false,
    is_low_stock: false,
    is_high_stock: false,
    percentage_stock_alarm: 10,
    percentage_high_stock_alarm: 10,
    time_high_stock_check: '11:00:00',
    minimum_credit: 10,
    payment_priority: 'CP,CB,TRD',
    temperature_unit: '°C',
    weight_unit: 'g',
    volume_unit: 'l',
    currency: '€',
    default_locale_customer: 'en-GB',
    default_locale_intervenor: 'fr-FR',
    has_coin_acceptor: true,
    has_banknote_reader: false,
    has_printer: true,
    has_id_card_reader: false,
    has_ask_age_confirmation: false,
    has_icoupon: false,
    user: 166,
    components: [],
}

export const terminal3 = {
    id: 103,
    name: 'Borne 3 mock',
    site: sites.site16,
    category: TypeMachine.enum.TERMINAL,
    description: '',
    stock_usage_percentage: 0,
    number_of_products: 0,
    max_products: 7,
    provider: '',
    software_version: '10',
    build_date: '2023-10-31',
    installation_date: '2023-10-31',
    distributor_volume: 10,
    connexion_type: 'et',
    paiement_method: 'ts',
    private_id: '',
    mode: '',
    enabled: false,
    online: false,
    is_low_stock: false,
    is_high_stock: false,
    percentage_stock_alarm: 10,
    percentage_high_stock_alarm: 10,
    time_high_stock_check: '11:00:00',
    minimum_credit: 10,
    payment_priority: 'CP,CB,TRD',
    temperature_unit: '°C',
    weight_unit: 'g',
    volume_unit: 'l',
    currency: '€',
    default_locale_customer: 'en-GB',
    default_locale_intervenor: 'fr-FR',
    has_coin_acceptor: true,
    has_banknote_reader: false,
    has_printer: true,
    has_id_card_reader: false,
    has_ask_age_confirmation: false,
    has_icoupon: false,
    user: 167,
    components: [],
}

export const terminal4 = {
    id: 104,
    name: 'Borne 4 mock',
    site: sites.site6,
    category: TypeMachine.enum.TERMINAL,
    description: '',
    stock_usage_percentage: 0,
    number_of_products: 0,
    max_products: 7,
    provider: '',
    software_version: '10',
    build_date: '2023-10-31',
    installation_date: '2023-10-31',
    distributor_volume: 10,
    connexion_type: 'et',
    paiement_method: 'ts',
    private_id: '',
    mode: '',
    enabled: false,
    online: false,
    is_low_stock: false,
    is_high_stock: false,
    percentage_stock_alarm: 10,
    percentage_high_stock_alarm: 10,
    time_high_stock_check: '11:00:00',
    minimum_credit: 10,
    payment_priority: 'CP,CB,TRD',
    temperature_unit: '°C',
    weight_unit: 'g',
    volume_unit: 'l',
    currency: '€',
    default_locale_customer: 'en-GB',
    default_locale_intervenor: 'fr-FR',
    has_coin_acceptor: true,
    has_banknote_reader: false,
    has_printer: true,
    has_id_card_reader: false,
    has_ask_age_confirmation: false,
    has_icoupon: false,
    user: 167,
    components: [],
}
